import { defineStore } from 'pinia'
import { hospitalSettingsApi } from '@/modules/settings/services/hospitalSettingsApi'
import type { OrganizationSettings } from '@/modules/settings/types/organizationSettings.types'

export const useOrganizationSettingsStore = defineStore('organizationSettings', {
  state: () => ({
    settings: null as OrganizationSettings | null,
    loading: false,
    loaded: false,
  }),
  actions: {
    async load(force = false) {
      if (this.loaded && !force) return this.settings

      this.loading = true
      try {
        this.settings = await hospitalSettingsApi.get()
        this.loaded = true
        return this.settings
      } finally {
        this.loading = false
      }
    },
    async save(payload: FormData | Record<string, unknown>) {
      this.settings = await hospitalSettingsApi.save(payload)
      this.loaded = true
      return this.settings
    },
    async deleteLogo() {
      this.settings = await hospitalSettingsApi.deleteLogo()
      this.loaded = true
      return this.settings
    },
  },
})
